import {Component, ElementRef, Injectable, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortal} from "@angular/cdk/portal";
import {Overlay} from "@angular/cdk/overlay";

@Injectable({
  providedIn: 'root'
})
export class HelpInformationService {
  globalOverlay = this.overlay.create({
    maxWidth: 300,
    hasBackdrop: false,
    panelClass: 'pane-help-information',
  });

  constructor(private overlay: Overlay) {
    this.globalOverlay.backdropClick().subscribe(() => this.hide());
  }

  show(origin: ElementRef<Component>, templateRef: TemplateRef<Component>, vcRef: ViewContainerRef) {
    const helpInformationTemplatePortal = new TemplatePortal(templateRef, vcRef);

    if (!this.globalOverlay.hasAttached()) {
      this.globalOverlay.updatePositionStrategy(
        this.overlay
          .position()
          .flexibleConnectedTo(origin)
          .withPositions([
            {
              originX: 'start',
              originY: 'top',
              overlayX: 'start',
              overlayY: 'bottom',
              offsetX: -5,
              offsetY: -15,
            }
          ])
          .withViewportMargin(25)
      );

      this.globalOverlay.attach(helpInformationTemplatePortal);
    }
  }

  hide() {
    if (this.globalOverlay.hasAttached()) {
      this.globalOverlay.detach();
    }
  }
}
